import Agent from './agent'

const agent = new Agent()

export const events = {
  all: (params) => agent.get('/api/event_history', { params }),
  stat: (params) => agent.get('/api/event_history', { params }),
  one: (id) => agent.get(`/api/event_history/${id}`),
}
